<div class="control-box">
  <img [src]="iconSrc" class="collectorIcon" /><a class="learnmore" href="{{ learnmore }}" target="_blank"
  >Learn More</a
  >
  <div [innerHTML]="title" class="title"></div>
  <div [innerHTML]="subtitle" class="subtitle mb8"></div>
  @if (_data && _data.length > 0) {
    <div [ngClass]="{ long: !isShowStatus }" class="actionBoxRow">
      <span>Name</span>
      @if (isShowStatus) {
        <span>Status</span>
      }
      @if (isEdit) {
        <span>Edit</span>
      }
      @if (isToken) {
        <span>Token</span>
      }
      @if (isDelete) {
        <span>Delete</span>
      }
    </div>
  }
  <div class="collectors">
    @for (obj of _data; track indexTrackBy(idx, obj); let idx = $index) {
      <div
        [ngClass]="{ long: !isShowStatus }"
        class="actionBoxRow"
        >
        <div class="input-container">
          <input
            [(ngModel)]="obj.name"
            [disabled]="obj.createdAt"
            [placeholder]="placeholderText.replace('{i}', idx + 1)"
            type="text"
            />
          @if (showCopyName && obj.fullName) {
            <img
              (click)="copyFullName(obj)"
              class="copyicon"
              src="/assets/svgs/copy.svg"
              title="Click to copy full service id for use in configs and sdks [{{ obj.fullName }}]"
              />
          }
        </div>
        @if (obj.createdAt && isShowStatus) {
          <div
            [ngStyle]="{ color: obj.online ? '#00DC5A' : '#e0e6e9' }"
            class="status"
            title="Identity Status"
            >
            &#9679;
          </div>
        }
        @if (!obj.createdAt && isCreate) {
          <app-action-button
            (selected)="create(obj)"
            [loading]="obj.action === 'creating'"
            icon="./assets/images/check.svg"
            name="createBtn"
            title="Create"
          ></app-action-button>
        }
        @if (obj.createdAt && isToken) {
          <app-action-button
            (selected)="token(obj)"
            [ngClass]="{ 'no-token': !obj.jwtExpiresAt }"
            class="tokenBtn-{{ idx }}"
            icon="./assets/images/Token.svg"
            name="tokenBtn"
            title="{{ !obj.jwtExpiresAt ? 'Identity token has already been consumed' : '' }}"
            title="Download your registration token"
          ></app-action-button>
        }
        @if (obj.createdAt && isEdit) {
          <app-action-button
            (selected)="edit(obj)"
            class="editBtn-{{ idx }}"
            icon="./assets/images/EditIcon.svg"
            name="editBtn"
            title="Edit this service"
          ></app-action-button>
        }
        @if (obj.createdAt && isDelete) {
          <app-action-button
            (selected)="delete(obj)"
            [loading]="obj.action === 'deleting'"
            icon="./assets/images/Delete.svg"
            name="deleteBtn"
            title="Delete"
          ></app-action-button>
        }
      </div>
    }
  </div>
  @if (allowAdd) {
    <div class="addButton mt16">
      <div
        (click)="onAdd()"
        [ngClass]="{ disabled: noAppSelected }"
        [title]="noAppSelected ? 'Please select an application before adding resources' : ''"
        class="button"
        >
        Add Another
      </div>
    </div>
  }
</div>
